document.addEventListener('DOMContentLoaded', () => {
    const __provenResultsSwipeable__ = document.querySelector('.proven-results__media-panels--swiper');
    const swiper = new Swiper(__provenResultsSwipeable__, {
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
    });
});